// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Customer from "./Customer.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactStately from "react-stately";
import * as Client from "@apollo/client";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

function customerKey(customer) {
  return Stdlib_Option.getOr(Primitive_option.fromNullable(customer.id), customer.name);
}

let Raw = {};

let query = Client.gql(["query CustomersSelectQuery($search: String, $filterBy: InputCustomersQueryFilter, $after: String, $first: Int)  {\ncustomers(search: $search, filterBy: $filterBy, after: $after, first: $first)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \nfirstName  \nlastName  \ncompanyName  \nkind  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.customers;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    customers: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.firstName;
        let value$3 = value$1.lastName;
        let value$4 = value$1.companyName;
        let value$5 = value$1.kind;
        let tmp;
        switch (value$5) {
          case "BUSINESS" :
            tmp = "BUSINESS";
            break;
          case "CONSUMER" :
            tmp = "CONSUMER";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            firstName: !(value$2 == null) ? value$2 : undefined,
            lastName: !(value$3 == null) ? value$3 : undefined,
            companyName: !(value$4 == null) ? value$4 : undefined,
            kind: tmp
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.customers;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.kind;
    let kind = value$2 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
    let value$3 = value$1.companyName;
    let companyName = value$3 !== undefined ? value$3 : null;
    let value$4 = value$1.lastName;
    let lastName = value$4 !== undefined ? value$4 : null;
    let value$5 = value$1.firstName;
    let firstName = value$5 !== undefined ? value$5 : null;
    let value$6 = value$1.id;
    let value$7 = value$1.__typename;
    let node = {
      __typename: value$7,
      id: value$6,
      firstName: firstName,
      lastName: lastName,
      companyName: companyName,
      kind: kind
    };
    let value$8 = value.__typename;
    return {
      __typename: value$8,
      node: node
    };
  });
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$3.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$3.__typename;
  let pageInfo = {
    __typename: value$6,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$7 = value$1.__typename;
  let customers = {
    __typename: value$7,
    pageInfo: pageInfo,
    edges: edges
  };
  return {
    customers: customers
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectNumberRangeFilter(inp) {
  let a = inp._min;
  let a$1 = inp._max;
  let a$2 = inp._between;
  return {
    _min: a !== undefined ? a : undefined,
    _max: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInputCustomersQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  let a$2 = inp.createdAt;
  let a$3 = inp.customerId;
  let a$4 = inp.kind;
  let a$5 = inp.hasSubscribedToLoyaltyProgram;
  let a$6 = inp.loyaltyPoints;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    archived: a$1 !== undefined ? (
        a$1 === "ONLY" ? "ONLY" : (
            a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    createdAt: a$2 !== undefined ? serializeInputObjectDateFilter(a$2) : undefined,
    customerId: a$3 !== undefined ? serializeInputObjectInFilter(a$3) : undefined,
    kind: a$4 !== undefined ? serializeInputObjectInFilter(a$4) : undefined,
    hasSubscribedToLoyaltyProgram: a$5 !== undefined ? ({
        _equals: a$5._equals
      }) : undefined,
    loyaltyPoints: a$6 !== undefined ? serializeInputObjectNumberRangeFilter(a$6) : undefined
  };
}

function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.filterBy;
  let a$2 = inp.after;
  let a$3 = inp.first;
  return {
    search: a !== undefined ? a : undefined,
    filterBy: a$1 !== undefined ? serializeInputObjectInputCustomersQueryFilter(a$1) : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined
  };
}

function makeVariables(search, filterBy, after, first) {
  return {
    search: search,
    filterBy: filterBy,
    after: after,
    first: first
  };
}

function makeInputObjectInputCustomersQueryFilter(shopIds, archived, createdAt, customerId, kind, hasSubscribedToLoyaltyProgram, loyaltyPoints, param) {
  return {
    shopIds: shopIds,
    archived: archived,
    createdAt: createdAt,
    customerId: customerId,
    kind: kind,
    hasSubscribedToLoyaltyProgram: hasSubscribedToLoyaltyProgram,
    loyaltyPoints: loyaltyPoints
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectNumberRangeFilter(_min, _max, _between, param) {
  return {
    _min: _min,
    _max: _max,
    _between: _between
  };
}

function makeDefaultVariables() {
  return {
    search: undefined,
    filterBy: undefined,
    after: undefined,
    first: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCustomersQueryFilter: serializeInputObjectInputCustomersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables,
  makeInputObjectInputCustomersQueryFilter: makeInputObjectInputCustomersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_use = include.use;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCustomersQueryFilter: serializeInputObjectInputCustomersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  makeVariables: makeVariables,
  makeInputObjectInputCustomersQueryFilter: makeInputObjectInputCustomersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: Query_use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function edgeToCustomer(edge) {
  return Stdlib_Option.map(Customer.makeName(edge.node.firstName, edge.node.lastName, edge.node.companyName), name => ({
    id: edge.node.id,
    name: name,
    business: edge.node.kind === "BUSINESS"
  }));
}

function useCustomersQuery(shopId, includeArchivedItems) {
  let apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let fetchPage = (search, after, param) => {
    let filterBy_shopIds = shopId !== undefined ? ({
        _in: [shopId]
      }) : undefined;
    let filterBy_archived = includeArchivedItems ? "INCLUDED" : "EXCLUDED";
    let filterBy = {
      shopIds: filterBy_shopIds,
      archived: filterBy_archived,
      createdAt: undefined,
      customerId: undefined,
      kind: undefined,
      hasSubscribedToLoyaltyProgram: undefined,
      loyaltyPoints: undefined
    };
    return apolloClient.rescript_query({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    }, undefined, undefined, "NetworkOnly", undefined, makeVariables(search, filterBy, after, 10));
  };
  let list = ReactStately.useAsyncList({
    load: async param => {
      let filterText = param.filterText;
      let search = filterText === "" ? undefined : filterText;
      let response = await fetchPage(search, param.cursor, undefined);
      if (response.TAG !== "Ok") {
        return {
          items: [],
          cursor: undefined
        };
      }
      let match = response._0;
      if (match.error !== undefined) {
        return {
          items: [],
          cursor: undefined
        };
      }
      let match$1 = match.data.customers;
      let pageInfo = match$1.pageInfo;
      return {
        items: Stdlib_Array.filterMap(match$1.edges, edgeToCustomer),
        cursor: Stdlib_Option.getOr(pageInfo.hasNextPage, false) ? pageInfo.endCursor : undefined
      };
    },
    getKey: customerKey
  });
  ReactUpdateEffect.use1(() => {
    list.reload();
  }, [shopId]);
  return list;
}

function CustomerSelect(props) {
  let onChange = props.onChange;
  let testCustomersResult = props.testCustomersResult;
  let __includeArchivedItems = props.includeArchivedItems;
  let __showNotSpecifiedItem = props.showNotSpecifiedItem;
  let __showDefaultItem = props.showDefaultItem;
  let __highlighted = props.highlighted;
  let highlighted = __highlighted !== undefined ? __highlighted : false;
  let showDefaultItem = __showDefaultItem !== undefined ? __showDefaultItem : false;
  let showNotSpecifiedItem = __showNotSpecifiedItem !== undefined ? __showNotSpecifiedItem : false;
  let includeArchivedItems = __includeArchivedItems !== undefined ? __includeArchivedItems : false;
  let list = useCustomersQuery(props.shopId, includeArchivedItems);
  let customers = testCustomersResult !== undefined ? testCustomersResult : list.items;
  let loading = testCustomersResult !== undefined ? false : list.isLoading;
  let match = React.useState(() => "");
  let setSearchValue = match[1];
  let searchValue = match[0];
  let delay = searchValue === "" ? 0 : 250;
  let debouncedSearchValue = ReactUpdateDebounced.use(searchValue, delay);
  ReactUpdateEffect.use1(() => {
    list.setFilterText(debouncedSearchValue);
  }, [debouncedSearchValue]);
  let notSpecifiedCustomer_id = null;
  let notSpecifiedCustomer_name = Stdlib_Option.getOr(props.notSpecifiedLabel, I18n.template(I18n.t("Not specified"), undefined, undefined));
  let notSpecifiedCustomer = {
    id: notSpecifiedCustomer_id,
    name: notSpecifiedCustomer_name,
    business: false
  };
  let value = Stdlib_Option.map(props.value, customer => {
    if (customer.id == null) {
      return notSpecifiedCustomer;
    } else {
      return customer;
    }
  });
  let makeItem = customer => ({
    TAG: "Option",
    key: customerKey(customer),
    label: customer.name,
    value: customer,
    endElement: customer.business ? JsxRuntime.jsx(Badge.make, {
        children: I18n.t("Pro"),
        size: "small",
        borderColor: "#A9C5E7",
        backgroundColor: "#F2F6FC",
        foregroundColor: "#4F70C1"
      }) : undefined
  });
  let customerItems = customers.map(makeItem);
  let items = value !== undefined && !(value.id == null) && !customers.some(param => param.id === value.id) ? [makeItem(value)].concat(customerItems) : customerItems;
  let defaultItem_1 = I18n.t("All");
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "__all__",
    label: defaultItem_1,
    value: undefined,
    exclusive: defaultItem_4
  };
  let notSpecifiedItem_1 = notSpecifiedCustomer_name;
  let notSpecifiedItem_2 = notSpecifiedCustomer;
  let notSpecifiedItem_4 = true;
  let notSpecifiedItem = {
    TAG: "Option",
    key: "__not-specified__",
    label: notSpecifiedItem_1,
    value: notSpecifiedItem_2,
    exclusive: notSpecifiedItem_4
  };
  let defaultItems = (
    showDefaultItem ? [defaultItem] : []
  ).concat(showNotSpecifiedItem ? [notSpecifiedItem] : []);
  let sections = defaultItems.length !== 0 ? [
      {
        items: defaultItems
      },
      {
        items: items,
        title: I18n.t("Customers")
      }
    ] : [{
        items: items,
        title: I18n.t("Customers")
      }];
  let onSelectionChange = selection => {
    if (selection.TAG === "Single") {
      return onChange(selection._0);
    }
  };
  let onSearch = React.useCallback(value => setSearchValue(param => value), []);
  let onToggle = React.useCallback(opened => {
    if (!opened) {
      return setSearchValue(param => "");
    }
  }, []);
  return JsxRuntime.jsx(Select.make, {
    label: props.label,
    placeholder: I18n.t("Select a customer"),
    preset: props.preset,
    searchable: true,
    size: props.size,
    highlighted: highlighted,
    loading: loading,
    onSearch: onSearch,
    onLoadMore: list.loadMore,
    onToggle: onToggle,
    sections: sections,
    value: {
      TAG: "Single",
      _0: value
    },
    onChange: onSelectionChange
  });
}

let make = React.memo(CustomerSelect);

export {
  customerKey,
  Query,
  edgeToCustomer,
  useCustomersQuery,
  make,
}
/* query Not a pure module */
